import { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import { Link, useLocation } from 'react-router-dom';
import './Login/Login.css'
import { useNavigate, NavLink } from 'react-router-dom';
import { Button, Grid2, Modal, Stack, Typography } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { ToastError, ToastSuccess } from '../../CustomToaster/CustomToaster';
import { updateAuthStatus, updateOtpTime } from '../../Actions/AuthAction';
import { resendOtp, TfaVerify } from '../../Services/auth';
import { useDispatch, useSelector } from 'react-redux';
import { InputError } from '../Errors/ErrorText';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import lightLogo from '../../Images/fouchain-logo-light.svg';
import darkLogo from "../../Images/fouchain-logo-dark.svg";
import { ThemeContext } from '../DarkMode/ThemeProvider';
import { useContext } from 'react';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'var(--color-BasicBg)',
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
};

const TwoFactor = () => {
    const { isLightMode } = useContext(ThemeContext);
    const navigate = useNavigate()
    //custom code
    const location = useLocation();
    const dispatch = useDispatch();

    const { method = "email", email, token } = location.state || {};
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [timeExpired, setTimerExpired] = useState(false);

    const { time } = useSelector((state) => state.auth);


    // const[targetTime,setTargetTime]=useState(location?.state?.data?.time)
    const reduxTime = useSelector((state) => state.auth.time);
    const [targetTime, setTargetTime] = useState(reduxTime);
    const [block, setBlock] = useState(false);

    const [pop7, setpop7] = useState(false);

    const handlePopOpen7 = async () => {
        setpop7(true);
    };
    const handlePopClose7 = async () => {
        setpop7(false);
    };


    const inputRefs = useRef([]);

    // Redirect if required state is missing
    useEffect(() => {

        if (!email) {
            ToastError({ message: "Invalid 2FA session. Please login again." });
            navigate("/login", { replace: true });
        }
    }, [email, navigate]);

    useEffect(() => {
        if (location?.state?.email) {
            // setEmail(location?.state?.email);
            if (location?.state?.data?.blocked) {
                setBlock(true);
                handlePopOpen7();
                setTargetTime(location?.state?.data?.time);
            }
        }

        setTargetTime(time);



    }, []);

    const handleInputChange = (value, index) => {
        if (!/^\d*$/.test(value)) return;
        const updatedOtp = [...otp];
        updatedOtp[index] = value;
        setOtp(updatedOtp);
        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
        setErrors({})
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        const pasted = e.clipboardData.getData('text').slice(0, 6);
        if (/^\d{6}$/.test(pasted)) {
            setOtp(pasted.split(''));
        }
    };

    const handleVerify2FA = async () => {
        const enteredOtp = otp.join('');
        if (enteredOtp.length !== 6) {
            setErrors({ otp: "Enter 6-digit code" });
            return;
        }

        setLoading(true);
        try {
            const { data } = await TfaVerify({ method: method, OTP: enteredOtp, email: location?.state?.email, type: "email", verifyType: "Twofa-Login" });
            if (data.success) {
                dispatch(updateAuthStatus(token));
                ToastSuccess({ message: data.message });
                localStorage.setItem("token", data.token); // or reuse the old one
                navigate("/portfolio", { replace: true });

            } else {
                setErrors({ otp: data.message || "Verification failed" });
            }
        } catch (err) {
            ToastError({ message: "Somthing went wrong" });
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        setResendLoading(true);
        try {
            const { data } = await resendOtp({
                type: "email",
                value: location?.state?.email,
                verifyType: "Twofa-Login"
            });

            if (data?.success === true) {
                setOtp(new Array(6).fill(""));
                dispatch(updateOtpTime(data?.result?.time));
                ToastSuccess({ message: data?.message, icon: false });

                // setTargetTime(data?.result?.time);
                setTimerExpired(false);
                // setEnableOtp(true);
                // setLoad(false);
            } else {
                if (data?.result?.blocked === true) {
                    dispatch(updateOtpTime(data?.result?.time));
                    // setBlock(true);
                    // setTargetTime(data?.result?.time);
                } else {
                    ToastError({ message: data?.message, icon: false });
                }
                // setLoad(false);
            }

        } catch (error) {
            ToastError({ message: "Resend failed" });
        } finally {
            setResendLoading(false);
        }
    };


    const CountdownTimer = ({ timestamp }) => {
        const [count, setCount] = useState(() => {
            const now = Date.now();
            return Math.max(Math.floor((timestamp - now) / 1000), 0);
        });

        useEffect(() => {
            if (count <= 0) {
                setTimerExpired(true);
                return;
            }

            const interval = setInterval(() => {
                const now = Date.now();
                const remaining = Math.max(Math.floor((timestamp - now) / 1000), 0);
                setCount(remaining);
            }, 1000);

            return () => clearInterval(interval);
        }, [timestamp, count]);

        const formatTime = (seconds) => {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${String(minutes).padStart(2, "0")}m:${String(secs).padStart(2, "0")}s`;
        };

        return <p className="timer">{formatTime(count)}</p>;
    };

    return (
        <Box>
            <div className='auth-page login-page'>
                <Grid container alignItems="center" justifyContent="center">
                    <Grid item xs={12} md={6}>
                        <Box className="login-card">
                            <div className="logo-part text-center">
                                <Link to='/'>
                                    <img src={!isLightMode ? lightLogo : darkLogo} alt='logo' width={150} />
                                </Link>
                            </div>

                            <div className='text-center mt-10'>
                                <Typography component="h1" sx={{ fontSize: '25px', textAlign: 'center' }}>
                                    2FA AUTHENTICATION
                                </Typography>
                            </div>

                            <p className='text-center mt-10'>Enter your 6-digit code from {method?.toLowerCase() === "email" ? `Email: ${email}` : "Google Authenticator"}.</p>

                            <div className='input-common OtpInput-number-main mt-30' style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 20 }}>
                                {otp.map((value, index) => (
                                    <TextField
                                        key={index}
                                        className="OtpInput-number"
                                        value={value}
                                        onChange={(e) => handleInputChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={handlePaste}
                                        inputRef={(el) => inputRefs.current[index] = el}
                                        inputProps={{ maxLength: 1, style: { textAlign: "center", width: "18px" } }}
                                        sx={{
                                            '& input': {
                                                fontSize: "18px",
                                                borderRadius: "4px",
                                                // backgroundColor: "#fff",
                                                color: "var(--color-PrimaryText)",
                                                caretColor: "var(--color-PrimaryText)"
                                            }
                                        }}
                                    />
                                ))}
                            </div>

                            <div className="text-center" style={{ marginTop: 10 }}>
                                <InputError error={errors.otp} />
                            </div>
                            {
                                (method?.toLowerCase() === "email" && block === false) &&

                                <div className="but-one text-center mt-30">
                                    {timeExpired ? (
                                        <Button onClick={handleResend} variant="outlined" disabled={resendLoading}>
                                            {resendLoading ? "Sending..." : "Resend OTP"}
                                        </Button>
                                    ) : (
                                        <CountdownTimer timestamp={time || Date.now() + 60000} />
                                    )}
                                </div>
                            }

                            <div className="but-one text-center mt-30">
                                <Button
                                    // onClick={handleVerify2FA}
                                    onClick={(e) => {
                                        if (block === true) {
                                            handlePopOpen7();
                                        } else {
                                            handleVerify2FA(e);
                                        }
                                    }}
                                    variant="contained" disabled={loading}>
                                    {loading ? "Verifying..." : "Submit"}
                                </Button>
                            </div>

                            <div className="register-acctn mt-30 display-3">
                                <p className='wcl-p fllname-ft'>Go to  <NavLink className='reg-free' to='/login'>Sign In</NavLink></p>
                            </div>

                        </Box>
                    </Grid>
                </Grid>
                <Toaster />
            </div>

            <div className="modal-popup text-center">
                <Modal
                    open={pop7}
                    // onClose={handlePopClose7}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <div className="display-2">
                            <h2>OTP Verification</h2>
                            <CancelRoundedIcon onClick={() => { handlePopClose7(); }} sx={{ color: "#3665FF", fontSize: "30px", cursor: "pointer" }} />
                        </div>

                        <div className="assistant-cnt">
                            <Grid2
                                container
                                justifyContent="center"
                                spacing={2}
                                sx={{ mt: 2 }}
                            >
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <div
                                        className="display-1 mt-20"
                                        style={{ justifyContent: "center" }}
                                    >
                                        <div className="text-center">
                                            <p>
                                                You’ve reached the maximum number of OTP attempts.
                                                Your account is blocked for{" "}
                                                <CountdownTimer
                                                    setTimerExpired={setTimerExpired}
                                                    timestamp={targetTime}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </Grid2>
                            </Grid2>
                        </div>

                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                            className="mt-20 assitant-stack"
                        ></Stack>
                    </Box>
                </Modal>
            </div>
        </Box>
    )
}

export default TwoFactor
